import { FC } from "react"
import { FlyoutFooter } from "@app/shared/Flyouts";
import { AccordionContainer } from "@app/shared";
import { EcdCountyByGapsAccordion } from "../components/EcdCountyByGapsAccordion";

interface County {
  canonicalRegionSetId: number;
  countySSA: string;
  name: string;
}

interface TopSpecialtiesFlyoutProps {
  counties: County[];
}


const EcdTopSpecialtiesFlyout: FC<TopSpecialtiesFlyoutProps> = (props: TopSpecialtiesFlyoutProps) => {
  return (
    <>
      <AccordionContainer>
        {props.counties.map((county) => {
          return (
            <EcdCountyByGapsAccordion
              canonicalRegionSetId={county.canonicalRegionSetId}
              countyName={county.name}
              key={county.countySSA}
              countySSA={county.countySSA}
            />
          )
        })}
      </AccordionContainer>
      <FlyoutFooter
        submitButton={null}
      />
    </>
  );
}

export default EcdTopSpecialtiesFlyout;
